import dayjs            from '~/lib/dayjs';
import React            from 'react';
import TimelineActivity from '~/components/drawers/timeline/activity';
import Tooltipable      from '~/components/effects/tooltipable';
import Avatar           from '~/components/shared/Avatar';

class TimelineActivityCampaignSubscription extends TimelineActivity {
  renderWhoTimestamp() {
    const { activity } = this.state;
    const { parameters: { trigger_name }, owner } = activity;
    const activity_owner = trigger_name ? { name: trigger_name } : (owner || { name: 'System' });

    return (
      <div className="text-grey mt10">
        <span className="pull-right text-grey">
          <Tooltipable
            text={dayjs(activity.occurred_at).format(
              'MMMM Do YYYY, h:mm:ss a',
            )}
          >
            <>{dayjs(activity.occurred_at).fromNow()}</>
          </Tooltipable>
        </span>
        {activity_owner.id ? (
          <>
            <Avatar name={activity_owner?.name} avatar={activity_owner?.avatar_url} sizeType="tiny" />
            {' '}
            {activity_owner?.name}
          </>
        ) : (
          <span>{activity_owner.name}</span>
        )}
      </div>
    );
  }
}

TimelineActivityCampaignSubscription.defaultProps = {
  title: (object) => {
    const { parameters: { campaign_name, trigger_name }, owner, key } = object.props.activity;
    const activity_owner = trigger_name ? { name: trigger_name } : (owner || { name: 'System' });

    switch (key) {
      case 'lead.campaign_subscription':
        return (
          `${campaign_name} was added by ${trigger_name ? 'campaign trigger' : ''} ${activity_owner.name}`
        );
      case 'lead.campaign_subscription_delete':
        return (
          `${campaign_name} was deleted by ${trigger_name ? 'campaign trigger' : ''} ${activity_owner.name}`
        );
      case 'lead.campaign_subscription.paused_due_to_text_reply':
        return (
          `${campaign_name} was paused. The campaign was paused because the contact replied to a campaign text`
        );
      case 'lead.campaign_subscription.paused_due_to_email_reply':
        return (
          `${campaign_name} was paused. The campaign was paused because the contact replied to a campaign email`
        );
      default:
        return (
          `${campaign_name} was ${key} by ${trigger_name ? 'campaign trigger' : ''} ${activity_owner.name}`
        );
    }
  },
  icon:           'exchange-alt',
  prefix:         'fas',
  alwaysPublic:   false,
};

export default TimelineActivityCampaignSubscription;
